import React__default from 'react';

const paymentsUIContextValues = {
    isProcessingOrder: false,
    setIsProcessingOrder: ()=>null
    ,
    paymentQRCodeState: undefined,
    setPaymentQRCodeState: ()=>null
    ,
    isQrCodeModalOpen: false,
    setIsQrCodeModalOpen: ()=>null
};
const PaymentsUIContext = /*#__PURE__*/ React__default.createContext(paymentsUIContextValues);
const usePaymentsUIContext = ()=>{
    const context = React__default.useContext(PaymentsUIContext);
    if (context === paymentsUIContextValues) {
        throw new Error('No PaymentUI Context available. You might still need to wrap the application with the paymentUIContextProvider component.');
    }
    return context;
};
PaymentsUIContext.displayName = 'PaymentsUIContext';
PaymentsUIContext.Consumer;

export { PaymentsUIContext, usePaymentsUIContext };
//# sourceMappingURL=context.js.map
